export const VIEW_WIDTH_SM = "calc(100vw - 50px)" 
export const VIEW_WIDTH_MD = "calc(100vw - 100px)" 
export const VIEW_WIDTH = "calc(100vw - 300px)" 
export const buttonBg = "#000";
// export const buttonBg = "#7C41FF";
export const buttonTextColor = "#fff";